import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e586576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "app-container__main" }

import { ref, watch, watchEffect, onMounted, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import UsersStore from '@apps/dashboard/src/store/usersStore';
import SidebarNavigation from '@shared/components/SidebarNavigation.vue';
import { AppHeader } from '@ds/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const keycloak = getCurrentInstance()?.appContext.config.globalProperties.$keycloak;

const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const { user } = UsersStore();

const pageTitle = ref();
const userName = ref('admin');
const userEmail = ref('');

watch(user, () => {
	if (!user.isAuthenticated) {
		router.push({ name: 'unauthorised' });
	}
});

watchEffect(() => {
	pageTitle.value = t(`routes.${route.meta.title}`);
});

onMounted(() => {
	if (user.preferredName) userName.value = user.preferredName;
	if (user.email) userEmail.value = user.email;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarNavigation, {
      "is-showing-homepage": _unref(user).hasAccessToHomepage
    }, null, 8, ["is-showing-homepage"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_unref(AppHeader), {
        title: pageTitle.value,
        "user-name": userName.value,
        "user-email": userEmail.value,
        "logout-label": _ctx.$t('globals.logout'),
        onLogout: _cache[0] || (_cache[0] = ($event: any) => (_unref(keycloak).logout()))
      }, null, 8, ["title", "user-name", "user-email", "logout-label"]),
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})